var _this = this;

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

;

(function (name, definition) {
  'undefined' != typeof module ? module.exports = definition() : 'function' == typeof define && 'object' == _typeof(define.amd) ? define(definition) : _this[name] = definition();
})('streamSaver', function () {
  'use strict';

  var iframe,
      loaded,
      secure = location.protocol == 'https:' || location.hostname == 'localhost',
      streamSaver = {
    createWriteStream: createWriteStream,
    supported: false,
    version: {
      full: '1.0.0',
      major: 1,
      minor: 0,
      dot: 0
    }
  };
  streamSaver.mitm = 'https://jimmywarting.github.io/StreamSaver.js/mitm.html?version=' + streamSaver.version.full;

  try {
    // Some browser has it but ain't allowed to construct a stream yet
    streamSaver.supported = 'serviceWorker' in navigator && !!new ReadableStream() && !!new WritableStream();
  } catch (err) {// if you are running chrome < 52 then you can enable it
    // `chrome://flags/#enable-experimental-web-platform-features`
  }

  function createWriteStream(filename, queuingStrategy, size) {
    // normalize arguments
    if (Number.isFinite(queuingStrategy)) {
      var _ref = [queuingStrategy, size];
      size = _ref[0];
      queuingStrategy = _ref[1];
    }

    var channel = new MessageChannel(),
        popup,
        setupChannel = function setupChannel() {
      return new Promise(function (resolve, reject) {
        channel.port1.onmessage = function (evt) {
          if (evt.data.download) {
            resolve();
            if (!secure) popup.close(); // don't need the popup any longer

            var link = document.createElement('a');
            var click = new MouseEvent('click');
            link.href = evt.data.download;
            link.dispatchEvent(click);
          }
        };

        if (secure && !iframe) {
          iframe = document.createElement('iframe');
          iframe.src = streamSaver.mitm;
          iframe.hidden = true;
          document.body.appendChild(iframe);
        }

        if (secure && !loaded) {
          var _fn;

          iframe.addEventListener('load', _fn = function fn(evt) {
            loaded = true;
            iframe.removeEventListener('load', _fn);
            iframe.contentWindow.postMessage({
              filename: filename,
              size: size
            }, '*', [channel.port2]);
          });
        }

        if (secure && loaded) {
          iframe.contentWindow.postMessage({
            filename: filename,
            size: size
          }, '*', [channel.port2]);
        }

        if (!secure) {
          popup = window.open(streamSaver.mitm, Math.random());

          var onready = function onready(evt) {
            if (evt.source === popup) {
              popup.postMessage({
                filename: filename,
                size: size
              }, '*', [channel.port2]);
              removeEventListener('message', onready);
            }
          }; // Another problem that cross origin don't allow is scripting
          // so popup.onload() don't work but postMessage still dose
          // work cross origin


          addEventListener('message', onready);
        }
      });
    };

    return new WritableStream({
      start: function start(error) {
        // is called immediately, and should perform any actions
        // necessary to acquire access to the underlying sink.
        // If this process is asynchronous, it can return a promise
        // to signal success or failure.
        return setupChannel();
      },
      write: function write(chunk) {
        // is called when a new chunk of data is ready to be written
        // to the underlying sink. It can return a promise to signal
        // success or failure of the write operation. The stream
        // implementation guarantees that this method will be called
        // only after previous writes have succeeded, and never after
        // close or abort is called.
        // TODO: Kind of important that service worker respond back when
        // it has been written. Otherwise we can't handle backpressure
        channel.port1.postMessage(chunk);
      },
      close: function close() {
        channel.port1.postMessage('end');
        console.log('All data successfully read!');
      },
      abort: function abort(e) {
        channel.port1.postMessage('abort');
      }
    }, queuingStrategy);
  }

  return streamSaver;
});